// extracted by mini-css-extract-plugin
export default {"dropzoneActiveWrapper":"asrDropzone_dropzoneActiveWrapper__WLalV","dropzoneTitle":"asrDropzone_dropzoneTitle__+1v-i"};